import React from 'react';
import { Navigate, Outlet, useOutletContext } from 'react-router-dom';

import HabilitationService from 'services/habilitationsService';

const ProtectedRoutes = () => {
    const context = useOutletContext();

    if(!HabilitationService || !HabilitationService.token || !HabilitationService.habilitations)
    {
      return <Navigate to="/" />;
    }
    else
    {
      return <Outlet context={context} /> ;
    }
};

export default ProtectedRoutes;